<template>
  <div class="privacy-policies">
    <cms-content type="1"/>
  </div>
</template>

<script>
  import CmsContent from '@/components/layout/CmsContent.vue'
  export default {
    components: {
      CmsContent
    }
  }
</script>
